import { ITutor } from '@wot/typings';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import tutorsApi from '../../../api/tutors';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../components/Table';
import TutorProfilePage from '../Requests/components/TutorProfile';
import { TableRowItem } from './components/TableRowItem';

export const statuses = {
  'under-review': 'Under Review',
  revision: 'Requires Revision',
  rejected: 'Rejected',
  'gen-agreement': 'Generate Agreement',
  'rev-agreement': 'Tutor Decision'
};

export default function TutorPage() {
  const [tutor, setTutor] = useState<ITutor>();
  const { tutor_id } = useParams();

  useEffect(() => {
    if (tutor_id) {
      tutorsApi.getTutorById(tutor_id).then((data) => setTutor(data))
    }
  }, [tutor_id]);

  if (!tutor) {
    return <p>Loading...</p>;
  }

  return (
    <div className="w-full flex flex-col gap-4 p-2">
      {/* <h1 className="text-xl font-semibold">{tutor.personal.data.name}&apos;s Profile</h1> */}
      <table className="w-full h-full table-auto">
        <TableHeading>
          <TableRow>
            <TableHeadingCol label="Date" />
            <TableHeadingCol label="Tutor ID" />
            <TableHeadingCol label="NAME" />
            <TableHeadingCol label="EMAIL" />
            <TableHeadingCol label="PHONE NO." />
            <TableHeadingCol label="CATEGORY" />
            <TableHeadingCol label="STATUS" />
          </TableRow>
        </TableHeading>
        <TableBody>
          <>
            <TableRow>
              <>
                <TableRowItem setTutor={setTutor} tutor={tutor} />
              </>
            </TableRow>
          </>
        </TableBody>
      </table>
      {/* <TutorReviewProgress tutor={tutor} /> */}
      <TutorProfilePage
        isRequest={false}
        tutor={tutor}
        setTutor={setTutor}
        mode={tutor.status === 'under-review' ? 'edit' : 'view'}
      />
    </div>
  );
}
